import { IPromise, IWindowService } from 'angular';
import { MobileConnect } from '../../models/mobile-connect.model';
import UtilService from '../util.service';

/* @ngInject */
export default class MobileConnectService {
  constructor(private config, private i18n, private $window: IWindowService) {}

  public buildUrl(
    msisdn: string,
    redirectUri: string = this.config.mobileConnect.redirect.url
  ): string {
    return this.createUrl(
      this.config.mobileConnect.url,
      this.createMobileConnect(msisdn, redirectUri)
    );
  }

  public createMobileConnect(
    msisdn: string,
    redirectUri: string
  ): MobileConnect {
    return angular.extend({}, this.config.mobileConnect.config, {
      msisdn,
      redirectUri
    });
  }

  public createUrl(endpoint: string, config: MobileConnect): string {
    const params = {
      acr_values: String(config.acr_values),
      claims_locales: this.getCurrentLanguageCode(config.claims_locales),
      client_id: config.client_id,
      display: config.display,
      login_hint: `ENCR_MSISDN:${encodeURIComponent(config.msisdn)}`,
      nonce: `Nonce${Math.random().toString(36)}`,
      prompt: config.prompt,
      redirect_uri: config.redirectUri,
      response_type: config.response_type,
      scope: config.scope,
      state: `State${Math.random().toString(36)}`,
      ui_locales: this.getCurrentLanguageCode(config.ui_locales)
    };

    return endpoint + '?' + UtilService.jsonToQueryString(params);
  }

  public openMobileConnectPage(msisdn: string): void {
    this.$window.location.href = this.buildUrl(msisdn);
  }

  private getCurrentLanguageCode(fallback: string): string {
    return this.i18n.getCurrentLanguage() || fallback;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/mobile-connect/mobile-connect.service.ts